(function(){
  // Sticky header (superseded by CSS, kept for safety)
  function initHeader(){
  var h=document.querySelector('header-component');
  if(!h)return;
  function u(){if(window.scrollY>40)h.classList.add('is-scrolled');else h.classList.remove('is-scrolled');}
  window.addEventListener('scroll',u,{passive:true});u();
  }

  // Karusellpiler ved overskriften (proxy-knapper som styrer originalpilene)
  function initHeadingArrows(sectionId){
  var section=document.getElementById(sectionId);
  if(!section)return;
  var textBlock=section.querySelector('.group-block-content .text-block');
  var arrowsEl=section.querySelector('slideshow-arrows');
  if(!textBlock||!arrowsEl)return;
  var prevBtn=arrowsEl.querySelector('.slideshow-control--previous');
  var nextBtn=arrowsEl.querySelector('.slideshow-control--next');
  if(!prevBtn||!nextBtn)return;
  if(section.querySelector('.knagen-heading-row'))return;

  function makeProxy(orig){
  var b=document.createElement('button');
  b.type='button';
  b.className='knagen-arrow-proxy';
  b.setAttribute('aria-label',orig.getAttribute('aria-label')||'');
  b.innerHTML=orig.innerHTML;
  b.style.cssText='background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;color:inherit;';
  if((orig.className||'').indexOf('flip-x')>-1){b.style.transform='scaleX(-1)';}
  function sync(){b.disabled=!!orig.disabled;b.style.opacity=orig.disabled?'0.35':'1';}
  b.addEventListener('click',function(e){e.preventDefault();orig.click();});
  try{new MutationObserver(sync).observe(orig,{attributes:true});}catch(err){}
  sync();
  return b;
  }

  var row=document.createElement('div');
  row.className='knagen-heading-row';
  row.style.cssText='display:flex;align-items:center;justify-content:center;gap:16px;width:100%;';
  row.appendChild(makeProxy(prevBtn));
  row.appendChild(textBlock.cloneNode(true));
  row.appendChild(makeProxy(nextBtn));
  textBlock.parentNode.insertBefore(row,textBlock);
  textBlock.remove();
  arrowsEl.style.cssText='position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);margin:-1px;';
  }

  function initInViewportFix(){
    try{
    var io=new IntersectionObserver(function(entries){
    for(var i=0;i<entries.length;i++){
    var en=entries[i];
    if(en.isIntersecting){en.target.setAttribute('in-viewport','');}else{en.target.removeAttribute('in-viewport');}
    }
    },{rootMargin:'200px'});
    document.querySelectorAll('slideshow-component').forEach(function(c){io.observe(c);});
    }catch(e){}
    }
    
    function init(){
  initHeader();
  initInViewportFix();
  initHeadingArrows('shopify-section-template--22379946606847__product_list_fa6P9H');
  initHeadingArrows('shopify-section-template--22379946606847__nylig_ankommet_pl');
  }

  if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
  } else {
  init();
  }
  })();